import React from "react";
import "./Adminvideofull.css";

const Adminvideo = () => {
  return (
    <div className="adminvideofull">
      <video src="https://youtu.be/m7QKruVSvKs?si=0CVfPAzE20WId6wf"></video>
      {/* <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/m7QKruVSvKs?si=0CVfPAzE20WId6wf"
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerpolicy="strict-origin-when-cross-origin"
        allowfullscreen
      ></iframe> */}
    </div>
  );
};

export default Adminvideo;
